import WPSResource from '../../../WPS.resource';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { METADATA_ACTION_KEYS, ROOT_REDUCER_KEYS } from '../../workspaceSettingsReducer';
export const defaultReducerState = getDefaultAsyncWrapperObj();
const getWorkspaceMetaDataPrefix = 'GetWorkspaceMetaData';
const workspaceMetaDataLoadEpicReducerArg = {
    actionPrefix: getWorkspaceMetaDataPrefix,
    reduxKeyNested: (inputPayload) => [ROOT_REDUCER_KEYS.METADATA, METADATA_ACTION_KEYS.GET],
    loadResource: (request) => WPSResource.getWorkspaceMetaData(request.workspaceId),
    onCompleteSuccess: (resourcesResult) => resourcesResult,
};
export const workspaceMetaDataLoadEpicReducer = loadResourcesUtils(workspaceMetaDataLoadEpicReducerArg);

//# sourceMappingURL=GetWorkspaceMetaData.ducks.js.map
